export const microServices = {
  NCMSV2: "ncms/v2",
};

export const endpoints = {
  DOWNLOAD_TEST_STATUS: `${microServices.NCMSV2}/usage/download-test-status`,
  RESULT_COMPARISION: `stats/v4/sbd/result-comparision`,
};
